export const connectionSteps = [
  {
    id: 1,
    step: '1. Download Dapp Wallet app or extension.'

  },
  {
    id: 2,
    step: '2. Switch to Polygon Mainnet'
    
  },
  {
    id: 3,
    step: '3. Transfer USDT/USDC to your Dapp wallet'
    
  },
  {
    id: 4,
    step: '4. Now you are ready to start interacting with application.'
    
  }
]